var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacationAndSickDaysOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    x1: 381.39,
    y1: 970.03,
    x2: 406.24,
    y2: 970.03,
    gradientTransform: "rotate(-17.54 -2493.544 1483.508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    "data-name": "C_BG_shellbar",
    x1: -5187.3,
    y1: 340.57,
    x2: -5156.52,
    y2: 340.57,
    gradientTransform: "scale(-1 1) rotate(5.475 21.413 53103.935)",
    xlinkHref: "#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    "data-name": "C_BG_shellbar",
    x1: -147.14,
    y1: -266.24,
    x2: -90.35,
    y2: -266.24,
    gradientTransform: "rotate(8.59 -2445.193 1453.903)",
    xlinkHref: "#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    "data-name": "C_BG_shellbar",
    x1: 76.15,
    y1: 27.98,
    x2: 118.41,
    y2: 27.98,
    xlinkHref: "#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    "data-name": "C_BG_shellbar",
    x1: 76.15,
    y1: 40.98,
    x2: 118.41,
    y2: 40.98,
    gradientTransform: "translate(0 -13)",
    xlinkHref: "#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f",
    "data-name": "C_BG_shellbar",
    x1: 85.72,
    y1: 69.98,
    x2: 110.29,
    y2: 69.98,
    xlinkHref: "#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M90.03 131.85H62.71c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.12M116.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64v65.86M91.21 121.7s4.23 6.45 9.57-.22M108.58 121.7s4.07 5.99 9.35 0c0 0 4.23 6.45 9.57-.22 0 0 4.23 6.68 9.9-.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M106.8 96.97s-2.5 3.9-4.78 17.38c-2.28 13.48-1.38 33.29-1.38 33.29s1.59 1.79 4.03 1.89c3.23.14 5.45-2.3 5.45-2.3s-4.45-12.24-.22-44.52",
    stroke: "url(#SVGID_0_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M117.03 90.37s2.25-1.04 5.14-3.55c2.89-2.51 5.47-7.08 5.47-7.08s-3.32.32-8.71 2.4c-5.39 2.08-8.21 5.71-8.21 5.71s-3.09-2.69-5.74-3.92c-2.65-1.24-5.52-1.63-5.52-1.63s1.81 5.68 5.07 7.82",
    stroke: "url(#SVGID_1_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M108.02 90.52s-6.64-.92-15.1 4.4c-6.81 4.82-8.46 6.68-8.46 6.68s5.45 2.24 14.54-1.34 9.86-5.41 9.86-5.41-.25 4.11 1.06 8.25c3.24 9.02 7.14 9.07 7.14 9.07s1.55-6.14-2.77-16.05c0 0 1.76 2.64 11.86 4.99 10.66 1.72 13.35-.33 13.35-.33s-3.56-6.01-13.35-8.68c-8.23-2.14-11.72-1.36-11.72-1.36",
    stroke: "url(#SVGID_2_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_3_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)",
    d: "M113.25 33.61l4.06-11.27H77.25l4.06 11.27h31.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_4_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)",
    d: "M113.25 33.61l4.06-11.27H77.25l4.06 11.27h31.94z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M108.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M71.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 115.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 98.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 79.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M86.16 75.36C86.73 69.32 91.82 64.6 98 64.6s11.22 4.68 11.83 10.67",
    stroke: "url(#SVGID_5_f2757b66fa5373951362feb9984e9a38e9df9c05a155f6c04ee47f863a89300f)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M86.16 75.36C86.73 69.32 91.82 64.6 98 64.6s11.22 4.68 11.83 10.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacationAndSickDaysOverview);
export default __webpack_public_path__ + "static/media/vacationAndSickDaysOverview.8f2f1b50d36fe70a2f74e1543b790232.svg";
export { ForwardRef as ReactComponent };